function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://stackoverflow.com/a/46971044/970769
var ParseError = function ParseError(code) {
  _classCallCheck(this, ParseError);

  this.name = this.constructor.name;
  this.message = code;
  this.stack = new Error(code).stack;
};

export default ParseError;


ParseError.prototype = Object.create(Error.prototype);
ParseError.prototype.constructor = ParseError;
//# sourceMappingURL=ParseError.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/libphonenumber-js/es6/ParseError.js
// module id = ../../../../libphonenumber-js/es6/ParseError.js
// module chunks = 3